<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-xl-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>Principais recursos da Trinka</h1>
                        <p>A Trinka, a primeira ferramenta de aprimoramento de gramática e linguagem do mundo, foi feita sob
                            medida para redação acadêmica e técnica. Suas características de destaque são que ele trabalha
                            com o autor e vai além da gramática e verificação ortográfica para garantir o aprimoramento holístico
                            da linguagem.</p>
                        <!-- <a id="FeaturesGetStarted" href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get Started</a> -->
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/FeaturesTopBanner.png" alt="Grammar Errors">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section backgrondSecitons_outer">
        <div class="container">
            <div class="row">
                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>Gramática avançada e verificação ortográfica</h2>
                        <div class="HeadingSubLine"></div>
                        <p>A escrita acadêmica precisa ser clara, concisa, formal, objetiva e legível. A Trinka ajuda você a
                            melhorar sua escrita em todas essas frentes para que sua escrita possa ser a melhor versão de
                            si mesmo.</p>
                    </div>
                </div>
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="spellcheckGrammerCheck" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="0" class="active">
                                        <span></span>
                                        Gramática avançada
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="1">
                                        <span></span>
                                        Estrutura da sentença
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="2">
                                        <span></span>
                                        Escolha da palavra
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="3">
                                        <span></span>
                                        Uso e estilo
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="4">
                                        <span></span>
                                        Estilo EUA/Reino Unido
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="5">
                                        <span></span>
                                        Ortografia avançada
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>Gramática avançada</h4>
                                    <p>A Trinka corrige mais de 3000 erros gramaticais complexos que outras ferramentas não
                                        corrigem. Com a Trinka, faça sua escrita limpa e clara.</p>
                                    <div class="featuresExampleText">
                                        <p>Neither the healthy individuals nor the patient
                                            <span class="wrongText">recognize</span>
                                            <span class="rightText">recognizes</span> the visual discrepancies.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Estrutura da sentença</h4>
                                    <p>A Trinka estrutura suas frases corretamente considerando sua àrea de assunto, tornando
                                        sua escrita fácil de entender.</p>
                                    <div class="featuresExampleText">
                                        <p>The students don't enjoy
                                            <span class="wrongText">to go</span>
                                            <span class="rightText">going</span> over the same rules again and again.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Escolha da palavra</h4>
                                    <p>A Trinka corrige o uso incorreto de palavras que torna sua escrita pouco clara. Transmita
                                        sua intenção com precisão e clareza com a Trinka.</p>
                                    <div class="featuresExampleText">
                                        <p>One of the reasons is
                                            <span class="wrongText">because</span>
                                            <span class="rightText">that</span> the fabrication cost
                                            <span class="wrongText">for</span>
                                            <span class="rightText">of</span> steel members depends upon the material.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Uso e estilo</h4>
                                    <p>A Trinka corrige frases e dá a sua escrita um tom formal. Impressione seus leitores com
                                        linguagem ousada e precisa.</p>
                                    <div class="featuresExampleText">
                                        <p>However, his method is novel and is
                                            <span class="wrongText">very much</span>
                                            <span class="rightText">considerably</span> different from the classical method.
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Estilo EUA/Reino Unido</h4>
                                    <p>Escolha entre o inglês dos EUA ou do Reino Unido e deixe a Trinka ajudá-lo a tornar sua
                                        escrita adequada para o seu público e estilo de periódico escolhido.</p>
                                    <div class="featuresExampleText">
                                        <p>The upper limbs of the patient were
                                            <span class="wrongText">paralysed</span>
                                            <span class="rightText">paralyzed.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Ortografia avançada</h4>
                                    <p>A verificação ortográfica contextual da Trinka ajuda você a escolher a palavra certa
                                        para a sua àrea de assunto. Não há mais erros de ortografia sem sentido.</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">Bonferoni</span>
                                            <span class="rightText">Bonferroni</span> test was used to check for statistical significance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider">
        <div class="container">
            <div class="row">
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="publishEnhancements" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#publishEnhancements" data-slide-to="0" class="active">
                                        <span></span>
                                        Preferências de estilo
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="1">
                                        <span></span>
                                        Redução de palavras
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="2">
                                        <span></span>
                                        Idioma imparcial
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="3">
                                        <span></span>
                                        Idioma vago
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="4">
                                        <span></span>
                                        Fraseamento técnico
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="5">
                                        <span></span>
                                        Tom acadêmico
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>Preferências do guia de estilo</h4>
                                    <p>A Trinka sugere fraseados preferidos por guias de estilo como AMA e APA. Prepare sua
                                        escrita para publicação com a Trinka.</p>
                                    <div class="featuresExampleText">
                                        <p>The man
                                            <span class="wrongText">suffered from</span>
                                            <span class="rightText">had</span> chronic kidney disease.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Redução da contagem de palavras</h4>
                                    <p>A Trinka transforma frases redundantes em frases concisas para você. Siga os pré-requisitos
                                        do periódico de forma simples!</p>
                                    <div class="featuresExampleText">
                                        <p>Bcl6 deficiency in T cells resulted in
                                            <span class="wrongText">the reduction of
                                            </span>
                                            <span class="rightText">reduced</span> mRNA expression.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Idioma imparcial</h4>
                                    <p>A Trinka corrige linguagem tendenciosa e insensível. Evite críticas e faça o seu ponto
                                        de vista de forma eficaz, com a Trinka.</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">retarded children</span>
                                            <span class="rightText">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Idioma vago</h4>
                                    <p>A Trinka ajuda a tornar sua escrita específica e direta. Uma comunicação eficaz é mais
                                        fácil com a Trinka.</p>
                                    <div class="featuresExampleText">
                                        <p>
                                            <span class="wrongText">Some studies</span>
                                            <span class="rightText">Studies</span> have shown that children not participating in co-curricular activities
                                            may not develop the necessary social skills in adulthood.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Fraseamento técnico</h4>
                                    <p>A Trinka sugere as palavras certas para usar em sua área de assunto. Faça seu conteúdo
                                        relacionável com seus leitores com a Trinka.</p>
                                    <div class="featuresExampleText">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span class="wrongText">transverse myelitis with long spinal cord lesions
                                            </span>
                                            <span class="rightText">longitudinally extensive transverse myelitis.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>Tom acadêmico</h4>
                                    <p>A Trinka dá a sua escrita um tom formal para que você possa impressionar seus leitores.
                                        A escrita profissional agora é fácil!</p>
                                    <div class="featuresExampleText">
                                        <p>Children actively engage in activities
                                            <span class="wrongText">like</span>
                                            <span class="rightText">such as</span> outdoor games, skits, and other team activities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>Melhorias no idioma pronto para publicação</h2>
                        <div class="HeadingSubLine"></div>
                        <p>A Trinka aumenta o tom, a entrega e o fraseamento de sua escrita de acordo com os padrões de publicação
                            acadêmica. Com a Trinka, a escrita acadêmica é agora livre de estresse.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <h2>Suíte do escritor</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections sections_height_set bg-right-position d-flex align-items-center" style="background-image: url('../../../assets/images/Reverstoolbox_backgrond_keyBenafits.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content pc-check-img">
                            <img src="../../../assets/images/pc-checker.png" alt="Plagiarism checker"/>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Verificação de Plágio</h3>
                            <p>
                                Desfrute da mais alta qualidade de verificação de plágio, com o algoritmo mais avançado de detecção de semelhanças de texto, iThenticate e o maior banco de dados de publicações pagas, cobrindo todas as áreas da ciência.
                            </p>
                            <a [routerLink]="['/features/plagiarism-check']">
                                Leia Mais
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Edição automática de arquivos</h3>
                            <p>Continue trabalhando em seu ambiente favorito. Carregue seu documento do MS Word e relaxe enquanto
                                o Trinka edita seu artigo automaticamente em minutos. Baixe seu arquivo com alterações de
                                rastreamento.
                            </p>
                            <a href="https://www.trinka.ai/pt/features/auto-file-edit">
                                Leia mais
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/autoFileEdit_image.png" alt="auto file edit">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections sections_height_set">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                            <ul>
                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/JournalScope.svg" alt="Journal Scope">
                                    </div>
                                    <h3>Journal Scope Match</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/TechnicalCompliance.svg" alt="Technical Compliance">
                                    </div>
                                    <h3>Conformidade técnica</h3>
                                    <span>3 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/EthicalCompliance.svg" alt="Ethical Compliance">
                                    </div>
                                    <h3>Conformidade ética</h3>
                                    <span>5 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/AuthorshipDetails.svg" alt="Authorship Details">
                                    </div>
                                    <h3>Detalhe da autoria</h3>
                                    <span>4 Checks</span>
                                </li>
                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/ReferenceDetails.svg" alt="Reference Details">
                                    </div>
                                    <h3>Detalhe da referência</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/FirgureTable.svg" alt="Figure Table">
                                    </div>
                                    <h3>Figuras e Tabelas</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/ClinicalTrials.svg" alt="clinical trials">
                                    </div>
                                    <h3>Informação do ensaio clínico</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/KeywordsAndSummary.svg" alt="keywords and summary">
                                    </div>
                                    <h3>Palavras-chave & Resumo</h3>
                                    <span>2 Checks</span>
                                </li>
                                <i></i>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Verificações de prontidão para publicação</h3>
                            <p>Com as verificações de prontidão de publicação da Trinka, você pode avaliar seu documento em
                                mais de 20 pontos de verificação, variando para Seleção de Revista para Compliance Ético,
                                para aumentar suas chances de ser publicado.</p>
                            <!-- <b style="font-weight: 600;">Coming soon</b> -->
                            <a href="https://www.trinka.ai/pt/features/publication-readiness-checks">
                                Leia mais
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Verificador de Citações</h3>
                            <p>O Verificador de Citações identifica citações que podem enfraquecer sua premissa de pesquisa e sua argumentação, e ajuda você a fazer citações com credibilidade e autoridade no seu artigo.
                            </p>
                            <a [routerLink]="['/features/citation-checker']">
                                Leia Mais
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="citationCheckAllFeaturSection">
                            <img src="../../../assets/images/CitationCheckAllFeaturePage.png" />
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Verificação de consistência</h3>
                            <p>Encontrou uma palavra melhor para fazer o seu ponto de vista, mas você pode ter hifenizado em
                                alguns casos e deixou alguns sem um hífen? A Verificação de Consistência do Trinka detecta
                                essa inconsistência em todo o seu texto, independentemente do comprimento, e permite que
                                você as revise com um clique.</p>
                            <!-- <a href="">Read More</a> -->
                            <a [routerLink]="['/features/consistency-check']">
                                Leia mais
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content consistency_checks_slider">
                            <div class="consistency_checks_slider_overlay"></div>
                            <div class="slider_consistency_check_section">
                                <div id="consistencySlider" class="carousel slide" data-ride="carousel">
                                    <ul class="carousel-indicators">
                                        <li data-target="#consistencySlider" data-slide-to="0" class="active"></li>
                                        <li data-target="#consistencySlider" data-slide-to="1"></li>
                                        <li data-target="#consistencySlider" data-slide-to="2"></li>
                                        <li data-target="#consistencySlider" data-slide-to="3"></li>
                                        <li data-target="#consistencySlider" data-slide-to="4"></li>
                                    </ul>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Dashes</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                                            <label for="ultra-violet">ultra-violet (5 occurrences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="ultra_violet" name="dashesCehcks">
                                                            <label for="ultra_violet">ultra violet (5 occurrences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similar alerts" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spacing</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="addSpaicng" name="spacingChecks" checked>
                                                            <label for="addSpaicng">Add space</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>p
                                                                <0 <img src="../../../assets/images/spacingArrow.png" />p
                                                                < 0 </li>
                                                                    <li>p=0
                                                                        <img src="../../../assets/images/spacingArrow.png" />p = 0 </li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="spacingChecks">
                                                            <label for="removingspacing">Remove space</label>
                                                        </p>
                                                        <ul>
                                                            <li>2D + DBT
                                                                <img src="../../../assets/images/spacingArrow.png" />2D+DBT</li>
                                                            <li>p
                                                                < 0 <img src="../../../assets/images/spacingArrow.png" />p
                                                                <0</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similar aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Numbers</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="spelledOut" name="numberschecks" checked>
                                                            <label for="spelledOut">Spelled-out
                                                                <img src="../../../assets/images/spacingArrow.png" /> Numeral</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>average six years
                                                                <img src="../../../assets/images/spacingArrow.png" />average 6 years </li>
                                                            <!-- <li>average 6 years <img src="../../../assets/images/spacingArrow.png"/>average six years </li> -->
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="numeralSection" name="numberschecks">
                                                            <label for="numeralSection">Numeral
                                                                <img src="../../../assets/images/spacingArrow.png" /> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>waited 5 days
                                                                <img src="../../../assets/images/spacingArrow.png" />waited five days</li>
                                                            <!-- <li>p < 0 <img src="../../../assets/images/spacingArrow.png"/>p<0</li> -->
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similar aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spelling</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="colourSection" name="spellingchecks" checked>
                                                            <label for="colourSection">colour (4 occurences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="colorSections" name="spellingchecks">
                                                            <label for="colorSections">color (4 occurences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similar aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Greek Letter Style</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="GreekSpelledOut" name="Greekletterstyle" checked>
                                                            <label for="GreekSpelledOut">Spelled-out
                                                                <img src="../../../assets/images/spacingArrow.png" /> Symbol</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>TNF-alpha"
                                                                <img src="../../../assets/images/spacingArrow.png" />tnf-α"</li>
                                                            <li>"Beta particles
                                                                <img src="../../../assets/images/spacingArrow.png" />"β particles</li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="Greekletterstyle">
                                                            <label for="removingspacing">Symbol
                                                                <img src="../../../assets/images/spacingArrow.png" /> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>TNF-α"
                                                                <img src="../../../assets/images/spacingArrow.png" />TNF-alpha"</li>
                                                            <li>"β particles
                                                                <img src="../../../assets/images/spacingArrow.png" />"beta particles</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similar aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <span>
                                            <i class="fa fa-plus"></i>Add to dictionary</span>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                        </li>
                                        <!-- <li><img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similar aterls" style="width: 22px;"></li> -->
                                        <li>
                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>
                                <!-- <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    <i class="fa fa-plus"  aria-hidden="true"></i> 
                                    <span class="dictionary_text_section">Add to dictionary</span>
                                    <span class="dictionary_add_text">Added</span>
                                </a> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Dicionário pessoal</h3>
                            <p>Adicione suas próprias palavras ao “Meu Dicionário” e Trinka não as sinalizará como erros ortográficos
                                em sua escrita futura.</p>
                            <!-- <a href="">Read More</a> -->
                            <a [routerLink]="['/features/personal-dictionary']">
                                Leia mais
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections downloadTrackedchangesOuter_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Baixar o arquivo alterado rastreado</h3>
                            <p>Baixe e finalize um arquivo alterado de faixa mostrando as várias alterações que você selecionou
                                no editor da Trinka.</p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="forMobileDownloadTrackChanges">
                            <img src="../../../assets/images/DownloadFileTrackChanges.png" />
                        </div>
                        <div class="toolbox_img_content downloadTrackedchanges_section">
                            <div class="downloadCleanFile">
                                <!-- <p class="cleanDownloadfile"></p> -->
                                <p>
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                            <div class="downloadWithTrackedChangesFile">
                                <!-- <p class="TrackedChangesFile"></p> -->
                                <p>
                                    <span class='wrognWordText'>On the other hand </span>
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='wrognWordText'>which influence </span>
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='wrognWordText'>leading to a reduction in </span>
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <b>
                                            <i class="fa fa-plus"></i>Add to dictionary</b>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <div class="acceptAll_buttons_sections">
                                        <p>Accept for all similar alerts</p>
                                        <i>
                                            <img src="../../../assets/images/info.svg" alt="info icon">
                                        </i>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                        </li>
                                        <li class="acceptAll_rejectAll">
                                            <img src="../../../assets/images/AcceptAll_consistencyCheks.svg" title="Ignore for all similar aterls" style="width: 22px;">
                                        </li>
                                        <li>
                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Aceitar/Ignorar tudo</h3>
                            <p>Chega de ficar clicando repetidamente! A Trinka permite que você aceite ou ignore todas as sugestões
                                repetitivas em um clique.</p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="writeToolbox_inner_sections publication_outer_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section acceptAll_outerSection">
                            <div class="acceptIgnore_all_section">
                                <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    <i class="fa fa-plus"  aria-hidden="true"></i> 
                                    <span class="dictionary_text_section">Add to dictionary</span>
                                    <span class="dictionary_add_text">Added</span>
                                </a>
                                <b>Accept for all similar alert</b>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Accept/Ignore All</h3>
                            <p>No more repetitive clicking! Trinka allows you to accept or ignore all repetitive
                                suggestions in one click.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

    </div>

    <div class="forpersonlized_sections">
        <p>O que você está esperando?</p>
        <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Cadastre-se Grátis</a>
    </div>
</div>